export const ItemGroupProp = Object.freeze({
    Items: 'items',
    SeparatedItems: 'separatedItems',
});